import React from "react";

const CostLogItemsContext = React.createContext({});

export default CostLogItemsContext;
